import { ReactElement, useEffect } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { InputSelectOption } from '~/components/input/InputSelect';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import { BreOrderContext, BreOrderMetadata } from '~/tenants/bre/model/BreOrderContext';
import BrePhotosExtra from '~/tenants/bre/performable/photos/BrePhotosExtra';
import BrePhotosJob from '~/tenants/bre/performable/photos/BrePhotosJob';

const PHOTOS_OPTS = Array.from({ length: 11 })
  .map((_, i) => i * 10 + 15)
  .map<InputSelectOption>((value) => ({
    label: `${value} Photos`,
    value: value.toFixed(0),
  }));

export default function BrePhotosFields({ context }: { context: BreOrderContext }): ReactElement {
  const [, photos, setPhotos] = useZodFormFieldSingle('photos');

  useEffect(() => {
    if (!photos) {
      const recommended = BrePhotosJob.recommendedPhotos(context.metadata);
      setPhotos(recommended.toFixed(0));
    }
  }, [photos]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <FormHorizontal name="photos" label="Minimum number of Photos recommended for your Property size" required>
        <ZodFieldSelect name="photos" options={PHOTOS_OPTS} />
      </FormHorizontal>
      <FormHorizontal label="Unsure about the package?">
        <BrePhotosExtra context={context} />
      </FormHorizontal>
    </>
  );
}
